import styled from 'styled-components';
import { FormGroup } from 'components/Form/subcomponents/FormGroup';
import { Select } from 'components/Form/subcomponents/Select';
import { colors, medias } from 'assets/styled/tokens';

import InputMask from 'react-input-mask';
import { ModalGeneric } from 'components';

import { StyledModalGenericBody, StyledModalGenericClose } from 'components/ModalGeneric/styled';

export const Page = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow-y: auto;
  background-color: #f5f3f1;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  //justify-content: center;
`;
export const FormWrapper = styled.div`
  //height: 100%;
  width: ${props => props.width};
  //border: 1px solid black;
  margin: 20px auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (min-width: ${medias.desktopSm}) {
    padding: 30px 0;
    margin: 30px auto;
    justify-content: center;
  }
`;
export const Header = styled.div`
  width: 100%;
`;
export const SubTitle = styled.h2`
  font-family: Blinker;
  font-weight: 700;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0px;
  margin: 18px 0;
  color: #000000;
`;
export const PageDisclaimer = styled.p`
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  color: #444444;
  margin-bottom: 32px;
`;
export const QrcodeUnitInfo = styled.h2`
  font-family: Roboto;
  font-weight: 400;
  font-style: italic;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0px;
  color: #808080;
`;
export const FormInputsWrapper = styled.div``;

export const StyledFormGroup = styled(FormGroup)`
  width: 100%;
  label {
    font-family: Roboto;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.3px;
    color: #1e1e1e;
  }
  input {
    width: ${props => props.width || '234px'};
  }
`;
export const StyledInputMask = styled(InputMask)`
  height: 32px;
  border: 1px solid ${props => (props.error ? 'red' : '#e7e7e7')};
`;
export const StyledSelect = styled(Select)`
  width: 299px;
  height: 32px;
  //border: 1px solid ${props => (props.error ? 'red' : '#e7e7e7')};
  input {
    height: 32px;
    border: 1px solid ${props => (props.error ? 'red' : '#e7e7e7')};
  }
  @media (min-width: ${medias.desktopSm}) {
    width: 569px;
    //border: 1px solid ${props => (props.error ? 'red' : '#e7e7e7')};
  }
  ul {
    background-color: #ffffff;
    max-height: 250px;
    top: 32px;
    width: 327px;
    border-radius: 0 0 1px 1px;
    @media (min-width: ${medias.desktopSm}) {
      width: 552px;
    }
    > div {
      display: none;
    }
    section {
      -ms-overflow-style: none;
      scrollbar-width: none;
      ::-webkit-scrollbar {
        display: none;
      }
      li {
        position: relative;
        height: 24px;
        //overflow: hidden;
        :not(:last-child) {
          border-bottom: 1px solid #e7e7e7;
        }
        input {
          height: 24px;
          border: none;
        }
        label {
          top: 0;
          font-family: Roboto;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.3px;
          color: #888888;
        }
      }
    }
  }
`;
export const ErrorText = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: #c25446;
  margin-bottom: 12px;
`;

export const SaveButton = styled.button`
  /* background-color: #f9e10d;
  border: 1px solid #000000; */
  width: 329px;
  height: 40px;
  border-radius: 4px;
  //color: #000000;
  font-family: Roboto;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
  text-align: center;
  background-color: ${p => p.theme.colors.primary};
  color: ${p => p.theme.colors.primaryText};
  border: 1px solid ${p => p.theme.colors.primaryBorder};
`;
export const SuccessModal = styled(ModalGeneric)`
  height: 316px;
  h6 {
    color: ${props => (props.success ? colors.successGreen : '#EC6655')};
    margin-bottom: 16px;
  }
  p {
    color: ${colors.gray};
    text-align: center;
    margin-bottom: 30px;
    font-size: 16px;
    line-height: 19px;
  }
  header {
    padding: 0 33px;
    @media (min-width: ${medias.desktopSm}) {
      padding: 0 141px;
    }
  }

  ${StyledModalGenericClose} {
    margin-right: -8px;
  }
  ${StyledModalGenericBody} button {
    font-size: 14px;
    line-height: 16px;
    width: 96px;
  }
`;
export const QrcodeTableInfo = styled.div`
  display: flex;
  border: 1px solid #dad1cd;
  width: ${({ width }) => width || '100%'};
`;
export const QrcodeTableInfoIcon = styled.div`
  width: 32px;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const QrcodeTableInfoBody = styled.div`
  display: flex;
  flex-direction: column;
  border-left: 1px solid #dad1cd;
  height: 65px;
  width: 100%;
  div:nth-child(2) {
    border-bottom: 1px solid #dad1cd;
  }
  div:not(:nth-child(2)) {
    height: 32px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 4px;
    color: #1e1e1e;
    font-size: 14px;
    gap: 2px;
  }
`;
